import axios from "axios";
import swal from "sweetalert2";

const productStore = {
  state: {
    item_type: "hidden",
    loading_search_results: null,
    loading_submit_form: null,
    products: [],
    discounts: [],
    groups: [],
    terms_template: "",
    subscription_visibility: "hidden",
    subscription_value: 0,
    index_modal: null,
    subscription_checked: 0,
    subscription_disabled: false,
    subscription_cycle_period: [],
    subscription_duration: 1,
    subscription_amount: 0,
    product_base_price: 0,
    product_image: null,
    eclipse_products: [],
    eclipse_product_results: [],
    group_eclipse_product_id: [],
    group_eclipse_product_name: [],
    group_eclipse_product_implementation: [],
    group_eclipse_product_cycle_start: [],
    group_eclipse_product_cycle_end: [],
    group_eclipse_product_cycle_cost_unused: [],
    group_eclipse_product_vendor_cost_unused: [],
    group_eclipse_product_edist_cut: [],
    group_eclipse_product_var_cut: [],
    group_eclipse_product_ces_cut: [],
  },
  mutations: {
    SET_ITEM_TYPE(state, locales) {
      // eslint-disable-next-line no-param-reassign
      state.item_type = locales;
    },
    SET_PRODUCTS(state, products) {
      // eslint-disable-next-line no-param-reassign
      state.products = products;
    },
    SET_LOADING_SEARCH_RESULTS(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.loading_search_results = val;
    },
    SET_LOADING_SUBMIT_FORM(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.loading_submit_form = val;
    },
    SET_DISCOUNTS(state, discounts) {
      // eslint-disable-next-line no-param-reassign
      state.discounts = discounts;
    },
    SET_GROUPS(state, groups) {
      // eslint-disable-next-line no-param-reassign
      state.groups = groups;
    },
    SET_TERMS_TEMPLATE(state, template) {
      // eslint-disable-next-line no-param-reassign
      state.terms_template = template;
    },
    SET_SUBSCRIPTION_VISIBILITY(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.has_subscription = val;
    },
    SET_SUBSCRIPTION_VALUE(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.subscription_value = val;
    },
    SET_SUBSCRIPTION_CHECKED(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.subscription_checked = val;
    },
    SET_SUBSCRIPTION_DISABLED(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.subscription_disabled = val;
    },
    SET_SUBSCRIPTION_DURATION(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.subscription_duration = val;
    },
    SET_SUBSCRIPTION_AMOUNT(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.subscription_amount = val;
    },
    SET_PRODUCT_BASE_PRICE(state, price) {
      // eslint-disable-next-line no-param-reassign
      state.product_base_price = price;
    },
    SET_TOTAL(state, data) {
      // eslint-disable-next-line no-param-reassign
      state.eclipse_products[data.index].total = data.total;
    },
    SET_CYCLE_COST_UNUSED(state, data) {
      // eslint-disable-next-line no-param-reassign
      state.eclipse_products[data.index].cycle_cost_unused = data.total;
    },
    SET_VENDOR_COST_UNUSED(state, data) {
      // eslint-disable-next-line no-param-reassign
      state.eclipse_products[data.index].vendor_cost_unused = data.total;
    },
    SET_EDIST_CUT(state, data) {
      // eslint-disable-next-line no-param-reassign
      state.eclipse_products[data.index].edist_cut = data.value;
    },
    SET_VAR_CUT(state, data) {
      // eslint-disable-next-line no-param-reassign
      state.eclipse_products[data.index].var_cut = data.value;
    },
    SET_CES_CUT(state, data) {
      // eslint-disable-next-line no-param-reassign
      state.eclipse_products[data.index].ces_cut = data.value;
    },
    SET_ECLIPSE_PRODUCT_NAME(state, data) {
      // eslint-disable-next-line no-param-reassign
      state.eclipse_products[data.index].product_name = data.description;
    },
    SET_ECLIPSE_PRODUCT_ID(state, data) {
      // eslint-disable-next-line no-param-reassign
      state.eclipse_products[data.index].product_id = data.id;
    },
    SET_PROD_IMPLEMENTATION(state, data) {
      // eslint-disable-next-line no-param-reassign
      state.eclipse_products[data.index].product_implementation = data.value;
    },
    SET_PROD_CYCLE_START(state, data) {
      // eslint-disable-next-line no-param-reassign
      state.eclipse_products[data.index].product_cycle_start = data.value;
    },
    SET_PROD_CYCLE_END(state, data) {
      // eslint-disable-next-line no-param-reassign
      state.eclipse_products[data.index].product_cycle_end = data.value;
    },
    INIT_ECLIPSE_PRODUCT(state, product) {
      // eslint-disable-next-line no-param-reassign
      state.eclipse_products = product;
    },
    ADD_NEW_ECLIPSE_PRODUCT(state, newProduct) {
      state.eclipse_products.push(newProduct);
    },
    REMOVE_PRODUCT(state, index) {
      state.eclipse_products.splice(index, 1);
    },
    SET_ECLIPSE_PRODUCT_RESULTS(state, results) {
      // eslint-disable-next-line no-param-reassign
      state.eclipse_product_results = results;
    },
    SET_INDEX_MODAL(state, index) {
      // eslint-disable-next-line no-param-reassign
      state.index_modal = index;
    },
    GROUP_ECLIPSE_PRODUCT_ID(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.group_eclipse_product_id = val;
    },
    GROUP_ECLIPSE_PRODUCT_NAME(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.group_eclipse_product_name = val;
    },
    GROUP_ECLIPSE_PRODUCT_IMPLEMENTATION(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.group_eclipse_product_implementation = val;
    },
    GROUP_ECLIPSE_PRODUCT_CYCLE_START(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.group_eclipse_product_cycle_start = val;
    },
    GROUP_ECLIPSE_PRODUCT_CYCLE_END(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.group_eclipse_product_cycle_end = val;
    },
    GROUP_ECLIPSE_CYCLE_COST_UNUSED(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.group_eclipse_product_cycle_cost_unused = val;
    },
    GROUP_ECLIPSE_VENDOR_UNUSED(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.group_eclipse_product_vendor_cost_unused = val;
    },
    GROUP_ECLIPSE_EDIST_CUT(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.group_eclipse_product_edist_cut = val;
    },
    GROUP_ECLIPSE_VAR_CUT(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.group_eclipse_product_var_cut = val;
    },
    GROUP_ECLIPSE_CES_CUT(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.group_eclipse_product_ces_cut = val;
    },
    SET_PRODUCT_IMAGE(state, file) {
      // eslint-disable-next-line no-param-reassign
      state.product_image = file;
    },
    SET_CYCLE_PERIOD(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.subscription_cycle_period = val;
    },
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    itemTypeChanged({ commit, state }, itemType) {
      if (itemType === "special") {
        commit("SET_ITEM_TYPE", null);
      } else {
        commit("SET_ITEM_TYPE", "hidden");
        // clear the subscription elements
        commit("SET_SUBSCRIPTION_CHECKED", false);
        commit("SET_SUBSCRIPTION_VALUE", 0);
        commit("SET_SUBSCRIPTION_DISABLED", false);
        commit("SET_CYCLE_PERIOD", []);
      }
    },

    switchSubscription({ commit }, val) {
      if (parseInt(val, 10) === 0) {
        commit("SET_SUBSCRIPTION_VALUE", 1);
        commit("SET_SUBSCRIPTION_CHECKED", true);
      }
      if (parseInt(val, 10) === 1) {
        commit("SET_SUBSCRIPTION_VALUE", 0);
        commit("SET_SUBSCRIPTION_CHECKED", false);
      }
    },

    loadingSubmitForm({ commit }, val) {
      commit("SET_LOADING_SUBMIT_FORM", val);
    },

    setSubscriptionValue({ commit }, val) {
      commit("SET_SUBSCRIPTION_VALUE", val);
    },

    setSubscriptionDurationAmount({ commit }, data) {
      commit("SET_SUBSCRIPTION_DURATION", data.duration);
      commit("SET_SUBSCRIPTION_AMOUNT", data.amount);
    },

    setMaxCyclesPeriod({ commit }, data) {
      commit("SET_CYCLE_PERIOD", data);
    },

    setBasePrice({ commit }, price) {
      commit("SET_PRODUCT_BASE_PRICE", price);
    },

    setEdistCutValue({ commit }, data) {
      commit("SET_EDIST_CUT", data);
    },

    setVarCutValue({ commit }, data) {
      commit("SET_VAR_CUT", data);
    },

    setCesCutValue({ commit }, data) {
      commit("SET_CES_CUT", data);
    },

    setProdImplementationValue({ commit }, data) {
      commit("SET_PROD_IMPLEMENTATION", data);
    },

    setProdCycleStart({ commit }, data) {
      commit("SET_PROD_CYCLE_START", data);
    },

    setProdCycleEnd({ commit }, data) {
      commit("SET_PROD_CYCLE_END", data);
    },

    setAllProdCycleEnd({ commit, state }, val) {
      const eclipseProducts = state.eclipse_products;

      eclipseProducts.forEach((product, index) => {
        commit("SET_PROD_CYCLE_END", { value: val, index });
      });
    },

    setProductImage({ commit }, file) {
      commit("SET_PRODUCT_IMAGE", file);
    },

    updateTotals({ commit, state }) {
      const cycleCost = state.product_base_price;
      const products = state.eclipse_products;

      products.forEach((product, index) => {
        let total = cycleCost;

        if (
          Number(product.product_cycle_end) <=
          Number(state.subscription_duration)
        ) {
          total -= state.subscription_amount;
        }

        const data = { total, index };

        commit("SET_CYCLE_COST_UNUSED", data);
        commit("SET_TOTAL", data);

        const vendorCostUnused =
          total - product.edist_cut - product.var_cut - product.ces_cut;
        commit("SET_VENDOR_COST_UNUSED", {
          total: vendorCostUnused,
          index,
        });
      });
    },

    updateAddonTotals({ commit, state }) {
      const cycleCost = state.product_base_price;
      const products = state.eclipse_products;

      products.forEach((product, index) => {
        let total = cycleCost;

        if (
          Number(product.product_cycle_end) <=
          Number(state.subscription_duration)
        ) {
          total -= state.subscription_amount;
        }

        const data = { total, index };

        commit("SET_CYCLE_COST_UNUSED", data);
        commit("SET_TOTAL", data);

        const vendorCostUnused =
          total - product.edist_cut - product.var_cut - product.ces_cut;
        commit("SET_VENDOR_COST_UNUSED", {
          total: vendorCostUnused,
          index,
        });
      });
    },

    setInitialProduct({ commit }) {
      commit("INIT_ECLIPSE_PRODUCT", [
        {
          product_name: "",
          product_id: "",
          product_implementation: "",
          edist_cut: 0,
          var_cut: 0,
          ces_cut: 0,
          product_cycle_start: 1,
          product_cycle_end: 1,
          cycle_cost_unused: 0,
          vendor_cost_unused: 0,
          total: 0,
        },
      ]);
    },

    addNewEclipseProduct({ commit }) {
      commit("ADD_NEW_ECLIPSE_PRODUCT", {
        product_name: "",
        product_id: "",
        product_implementation: "",
        edist_cut: 0,
        var_cut: 0,
        ces_cut: 0,
        product_cycle_start: 1,
        product_cycle_end: 1,
        cycle_cost_unused: 0,
        vendor_cost_unused: 0,
        total: 0,
      });
    },

    removeProduct({ commit }, index) {
      commit("REMOVE_PRODUCT", index);
    },

    setIndexModal({ commit }, index) {
      commit("SET_INDEX_MODAL", index);
    },

    setEclipseProductName({ commit }, data) {
      commit("SET_ECLIPSE_PRODUCT_NAME", data);
      commit("SET_ECLIPSE_PRODUCT_ID", data);
    },

    clearEclipseSearchResults({ commit }) {
      commit("SET_ECLIPSE_PRODUCT_RESULTS", []);
    },

    groupEclipseProductData({ commit, state }) {
      const productIds = [];
      const productNames = [];
      const productImplementation = [];
      const productCycleStart = [];
      const productCycleEnd = [];
      const cycleCostUnused = [];
      const vendorCostUnused = [];

      const edistCut = [];
      const varCut = [];
      const cesCut = [];

      state.eclipse_products.forEach((prod) => {
        productIds.push(prod.product_id);
        productNames.push(prod.product_name);
        productImplementation.push(prod.product_implementation);
        productCycleStart.push(prod.product_cycle_start);
        productCycleEnd.push(prod.product_cycle_end);
        cycleCostUnused.push(prod.cycle_cost_unused);
        vendorCostUnused.push(prod.vendor_cost_unused);
        edistCut.push(prod.edist_cut);
        varCut.push(prod.var_cut);
        cesCut.push(prod.ces_cut);
      });

      commit("GROUP_ECLIPSE_PRODUCT_ID", productIds);
      commit("GROUP_ECLIPSE_PRODUCT_NAME", productNames);
      commit("GROUP_ECLIPSE_PRODUCT_IMPLEMENTATION", productImplementation);
      commit("GROUP_ECLIPSE_PRODUCT_CYCLE_START", productCycleStart);
      commit("GROUP_ECLIPSE_PRODUCT_CYCLE_END", productCycleEnd);
      commit("GROUP_ECLIPSE_CYCLE_COST_UNUSED", cycleCostUnused);
      commit("GROUP_ECLIPSE_VENDOR_UNUSED", vendorCostUnused);

      commit("GROUP_ECLIPSE_EDIST_CUT", edistCut);
      commit("GROUP_ECLIPSE_VAR_CUT", varCut);
      commit("GROUP_ECLIPSE_CES_CUT", cesCut);
    },

    async getProducts({ commit }) {
      try {
        const response = await axios.get("/all-products");
        commit("SET_PRODUCTS", response.data);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error.response);
      }
    },

    async getDiscounts({ commit }) {
      try {
        const response = await axios.get("/all-discounts");
        commit("SET_DISCOUNTS", response.data);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error.response);
      }
    },

    async getGroups({ commit }) {
      try {
        const response = await axios.get("/all-groups");
        commit("SET_GROUPS", response.data);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error.response);
      }
    },

    // eslint-disable-next-line no-unused-vars
    async loadSubscription({ commit, state }, productId) {
      try {
        if (productId) {
          const response = await axios.post(
            "/products/productSubscriptionAjax",
            {
              product_ref: productId,
            }
          );
          const { result } = response.data;
          const { data } = response.data;

          if (result === 1 && data.has_subscription) {
            commit("SET_SUBSCRIPTION_CHECKED", true);
            commit("SET_SUBSCRIPTION_VALUE", 1);
            commit("SET_SUBSCRIPTION_DISABLED", true);
            commit("SET_CYCLE_PERIOD", data);
          }
        } else {
          commit("SET_SUBSCRIPTION_CHECKED", false);
          commit("SET_SUBSCRIPTION_VALUE", 0);
          commit("SET_SUBSCRIPTION_DISABLED", false);
          commit("SET_CYCLE_PERIOD", []);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error.response);
      }
    },

    async searchEclipseProduct({ commit }, criteria) {
      commit("SET_LOADING_SEARCH_RESULTS", true);
      try {
        const response = await axios.post("/products/loadEclipseProducts", {
          search: criteria,
          type: "raw",
        });

        if (response.data.result === 1) {
          commit("SET_ECLIPSE_PRODUCT_RESULTS", response.data.data);
        }
        commit("SET_LOADING_SEARCH_RESULTS", false);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error.response);
        commit("SET_LOADING_SEARCH_RESULTS", false);
      }
    },

    async submitAddNewProductForm({ commit }, fields) {
      commit("SET_LOADING_SUBMIT_FORM", true);
      try {
        const response = await axios({
          url: "/products/new",
          method: "post",
          transformRequest(data) {
            const formData = new FormData();
            formData.append("label", data.allFields.label);
            formData.append("sku", data.allFields.sku);
            formData.append("locale_id", data.allFields.locale_id);
            formData.append("base_price", data.allFields.base_price);
            formData.append("product_ref", data.allFields.product_ref);
            formData.append("group", data.allFields.group);
            formData.append("nexus", data.allFields.nexus);
            formData.append("description", data.allFields.description);
            formData.append("terms", data.allFields.terms);
            formData.append(
              "eclipse_product",
              JSON.stringify(data.allFields.eclipse_product)
            );
            formData.append(
              "eclipse_product_name",
              JSON.stringify(data.allFields.eclipse_product_name)
            );
            formData.append(
              "product_implementation",
              JSON.stringify(data.allFields.product_implementation)
            );
            formData.append(
              "product_cycle_start",
              JSON.stringify(data.allFields.product_cycle_start)
            );
            formData.append(
              "product_cycle_end",
              JSON.stringify(data.allFields.product_cycle_end)
            );
            formData.append(
              "edist_cut",
              JSON.stringify(data.allFields.edist_cut)
            );
            formData.append("var_cut", JSON.stringify(data.allFields.var_cut));
            formData.append("ces_cut", JSON.stringify(data.allFields.ces_cut));
            formData.append("image", data.prodImage);
            formData.append("item_type", data.allFields.item_type);
            if (data.allFields.item_type === "special") {
              formData.append(
                "product_discounts",
                data.allFields.product_discounts
              );
            }
            formData.append(
              "has_subscription",
              data.allFields.has_subscription
            );
            if (data.allFields.has_subscription) {
              formData.append("max_cycles", data.allFields.max_cycles);
            }
            formData.append("period", data.allFields.period);

            return formData;
          },
          data: { allFields: fields, prodImage: fields.image },
        });

        if (response.status === 200) {
          swal.fire({
            type: "success",
            title: "Success",
            html: "<h5>New product was added.</h5><br/>",
            showConfirmButton: false,
          });
          window.location.href = "/products";
        } else {
          swal.fire({
            type: "error",
            title: "Oops...",
            html:
              "<h5>Something went wrong!</h5><br/>" +
              "<h5>Please refresh the page and try again.</h5><br/>",
            showConfirmButton: true,
          });
        }
      } catch (error) {
        swal.fire({
          type: "error",
          title: "Error",
          html: `<h5>${error.response.data.message}</h5><br/>`,
          showConfirmButton: true,
        });
      }
      commit("SET_LOADING_SUBMIT_FORM", false);
    },
  },
};

export default productStore;
